<template>
  <div id="mainDiv" v-if="viewFlag">
    <p style="text-align: center;margin-bottom: 2%;">
      <!-- 上课记录 -->
      <span class="systemFont1">{{
        $t("p0212.personalUser") + $t("common.query")
      }}</span>
    </p>
    <el-form
      :model="queryForm"
      label-position="right"
      ref="queryForm"
      label-width="90px"
      class="systemFont1"
    >
      <el-row>
        <el-col :span="24">
          <div v-show="showSearch">
            <el-row>
              <!-- 个人用户检索入力框 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('p0212.personalUser')"
                  prop="queryCriteria"
                >
                  <el-input
                    type="text"
                    size="small"
                    v-model="queryForm.queryCriteria"
                    clearable
                    :placeholder="$t('p0212.searchPlaceholder')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 关联公司 -->
              <el-col :span="6">
                <el-form-item
                  :label="$t('p0212.existingCompany')"
                  prop="existingCompany"
                >
                  <el-input
                    type="text"
                    size="small"
                    v-model="queryForm.existingCompany"
                    clearable
                    :placeholder="$t('emailGroup.fuzzySearch')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 销售人员 -->
              <el-col :span="6">
                <el-form-item :label="$t('p0213.salesUser')" prop="salesPerson">
                  <el-input
                    type="text"
                    size="small"
                    v-model="queryForm.salesPerson"
                    clearable
                    :placeholder="$t('emailGroup.fuzzySearch')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- 职位 -->
              <el-col :span="6">
                <el-form-item :label="$t('p0211.position')" prop="position">
                  <el-input
                    type="text"
                    size="small"
                    v-model="queryForm.position"
                    clearable
                    :placeholder="$t('emailGroup.fuzzySearch')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <!-- TQS操作 -->
              <el-col :span="6">
                <el-form-item :label="$t('p0213.tqsOpr')" prop="tqsOperation">
                  <el-input
                    type="text"
                    size="small"
                    v-model="queryForm.tqsOperation"
                    clearable
                    :placeholder="$t('emailGroup.fuzzySearch')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <!-- TQS积分 -->
              <el-col :span="6">
                <el-form-item :label="$t('p0213.tqsPoints')">
                  <el-col :span="10">
                    <el-form-item label-width="0px" prop="tqsPoints1">
                      <el-input
                        type="number"
                        @keydown.native="clearInput"
                        size="small"
                        v-model="queryForm.tqsPoints1"
                        clearable
                      ></el-input
                    ></el-form-item>
                  </el-col>
                  <el-col :span="4"> — </el-col>
                  <el-col :span="10">
                    <el-form-item label-width="0px" prop="tqsPoints2">
                      <el-input
                        type="number"
                        @keydown.native="clearInput"
                        size="small"
                        v-model="queryForm.tqsPoints2"
                        clearable
                      ></el-input
                    ></el-form-item>
                  </el-col>
                </el-form-item>
              </el-col>
              <!-- 上次登录 -->
              <el-col :span="6">
                <el-form-item :label="$t('p0213.lastLogin')" prop="lastLogin">
                  <el-date-picker
                    size="small"
                    v-model="queryForm.lastLogin"
                    type="daterange"
                    format="yyyy-MM-dd"
                    style="width:100%"
                    value-format="yyyy-MM-dd"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <!-- 内训授权员工 -->
              <el-col :span="6">
                <el-form-item :label="$t('p0213.isInternalTrainingAuthorized')" prop="isInternalTrainingAuthorized">
                  <el-select
                    size="small"
                    v-model="queryForm.isInternalTrainingAuthorized"
                    clearable
                    :placeholder="$t('common.pleaseSelect')"
                    style="width:100%"
                  >
                    <el-option :label="$t('common.yes')" value="1"></el-option>
                    <el-option :label="$t('common.not')" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row>
            <el-col :span="8">
              <div style=" padding:5px 0 15px 0;float: left; ">
                <!-- 查询 -->
                <el-button
                  type="primary"
                  size="small"
                  @click="getUserDetail(true)"
                  >{{ $t("common.search") }}</el-button
                >
                <!-- 重置 -->
                <el-button @click="reset" size="small">{{
                  $t("common.reset")
                }}</el-button>
                <!-- 导出优惠码 -->
                <el-button
                  type="primary"
                  size="small"
                  @click="exportCouponCode"
                  >{{ $t("p0212.export") }}</el-button
                >
              </div>
            </el-col>
            <div style="float: right;">
              <RightToolbar
                ref="rightToolbarRef"
                :showSearch.sync="showSearch"
                :columns="columns"
              ></RightToolbar>
            </div>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col>
        <el-table
          ref="userDetailTable"
          :data="individualUserDetails"
          v-loading="pageLoading"
          tooltip-effect="dark"
          :key="tableKey"
        >
          <!-- 头像 -->
          <el-table-column
            :label="$t('p0212.headPortrait')"
            align="center"
            min-width="70"
            v-if="columns[0].visible"
          >
            <template slot-scope="scope">
              <el-avatar
                :src="viewHeadPortrait(scope.row.headPortrait)"
                :key="scope.row.headPortrait"
                :size="30"
              ></el-avatar>
            </template>
          </el-table-column>
          <!-- 姓名-->
          <el-table-column
            prop="name"
            :label="$t('p0212.userName')"
            align="left"
            v-if="columns[1].visible"
            min-width="120"
          ></el-table-column>
          <!-- 英文姓名 -->
          <el-table-column
            prop="englishName"
            v-if="columns[2].visible"
            :label="$t('p0212.englishName')"
            align="left"
            min-width="120"
          ></el-table-column>
          <!-- 昵称 -->
          <el-table-column
            prop="nickName"
            v-if="columns[3].visible"
            :label="$t('p0212.nickname')"
            align="left"
            min-width="100"
          ></el-table-column>
          <!-- 优惠码 -->
          <el-table-column
            prop="couponCode"
            v-if="columns[4].visible"
            :label="$t('p0212.couponCode')"
            align="center"
            min-width="90"
          ></el-table-column>
          <!-- 优惠码级别 -->
          <el-table-column
            prop="couponCodeLevel"
            v-if="columns[5].visible"
            :label="$t('p0212.couponCodeLevel')"
            align="center"
            min-width="100"
          ></el-table-column>
          <!-- 关联公司 -->
          <el-table-column
            prop="existingCompany"
            v-if="columns[6].visible"
            :label="$t('p0212.existingCompany')"
            align="left"
            min-width="120"
          ></el-table-column>
          <!-- 职位 -->
          <el-table-column
            prop="position"
            v-if="columns[7].visible"
            :label="$t('p0211.position')"
            align="left"
            min-width="150"
          ></el-table-column>
          <!-- 内训授权员工 -->
          <el-table-column
            prop="isInternalTrainingAuthorized"
            v-if="columns[15].visible"
            :label="$t('p0213.isInternalTrainingAuthorized')"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              {{ scope.row.isInternalTrainingAuthorized === '1' ? $t('common.yes') : $t('common.not') }}
            </template>
          </el-table-column>
          <!-- 注册日期 -->
          <el-table-column
            prop="registerDate"
            v-if="columns[8].visible"
            :label="$t('p0212.registerDate')"
            align="center"
            min-width="120"
          ></el-table-column>
          <!-- 介绍人 -->
          <el-table-column
            prop="introducer"
            v-if="columns[9].visible"
            :label="$t('p0212.introducer')"
            align="center"
            min-width="120"
          ></el-table-column>
          <!-- 销售人员 -->
          <el-table-column
            prop="salesPerson"
            v-if="columns[10].visible"
            :label="$t('p0213.salesUser')"
            align="center"
            min-width="120"
          ></el-table-column>
          <!-- TQS操作 -->
          <el-table-column
            prop="tqsOperation"
            v-if="columns[11].visible"
            :label="$t('p0213.tqsOpr')"
            align="left"
            min-width="200"
          ></el-table-column>
          <!-- TQS积分 -->
          <el-table-column
            prop="tqsPoints"
            v-if="columns[12].visible"
            :label="$t('p0213.tqsPoints')"
            align="center"
            min-width="100"
          ></el-table-column>
          <!-- 上次更新 -->
          <el-table-column
            prop="lastUpdateDate"
            v-if="columns[13].visible"
            :label="$t('p0212.lastUpdateDate')"
            align="center"
            min-width="100"
          ></el-table-column>
          <!-- 上次登录 -->
          <el-table-column
            prop="lastLogin"
            v-if="columns[14].visible"
            :label="$t('p0213.lastLogin')"
            align="center"
            min-width="100"
          ></el-table-column>
          <!-- 操作 -->
          <el-table-column
            :label="$t('p0212.operate')"
            align="center"
            min-width="60"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="
                  detail(
                    scope.row,
                    scope.row.userId,
                    scope.row.documentAppendix01,
                    scope.row.documentAppendix02
                  )
                "
                >&nbsp;{{ $t("p0212.details") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 分页 -->
    <el-row style="text-align: right; margin: 20px">
      <el-col :span="24">
        <div class="block">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-row><br /><br /></el-row>
  </div>
</template>

<script>
import qs from "qs";
import moment, { now } from "moment";
// 自定义表格工具组件
import RightToolbar from "../../components/RightToolbar/index.vue";
export default {
  components: {
    RightToolbar
  },
  data() {
    return {
      tableKey: "random_string",
      // 列信息
      columns: [
        { key: 0, label: this.$t("p0212.headPortrait"), visible: true },
        { key: 1, label: this.$t("p0212.userName"), visible: true },
        { key: 2, label: this.$t("p0212.englishName"), visible: true },
        { key: 3, label: this.$t("p0212.nickname"), visible: true },
        { key: 4, label: this.$t("p0212.couponCode"), visible: true },
        { key: 5, label: this.$t("p0212.couponCodeLevel"), visible: true },
        { key: 6, label: this.$t("p0212.existingCompany"), visible: true },
        { key: 7, label: this.$t("p0211.position"), visible: true },
        { key: 8, label: this.$t("p0212.registerDate"), visible: true },
        { key: 9, label: this.$t("p0212.introducer"), visible: true },
        { key: 10, label: this.$t("p0213.salesUser"), visible: true },
        { key: 11, label: this.$t("p0213.tqsOpr"), visible: true },
        { key: 12, label: this.$t("p0213.tqsPoints"), visible: true },
        { key: 13, label: this.$t("p0212.lastUpdateDate"), visible: true },
        { key: 14, label: this.$t("p0213.lastLogin"), visible: true },
        { key: 15, label: this.$t("p0213.internalTrainingAuthorized"), visible: true }
      ],
      // 查询条件
      queryForm: {
        queryCriteria: "",
        existingCompany: "",
        salesPerson: "",
        position: "",
        tqsOperation: "",
        lastLogin: [],
        tqsPoints1: "",
        tqsPoints2: "",
        isInternalTrainingAuthorized: ""
      },
      // 个人用户一览
      individualUserDetails: [],
      // 页面载入状态
      pageLoading: false,
      viewFlag: true,
      // 当前页
      currentPage: 1,
      // 每页件数
      pageSize: 20,
      total: 0,
      amount: "",
      // 显示搜索条件
      showSearch: true,
      // 默认头像图片
      defaultImg: require("../../assets/headPortrait.png"),
      // 检索条件保持变量
      tmpQueryStr: {
        queryCriteria: "",
        existingCompany: "",
        salesPerson: "",
        position: "",
        tqsOperation: "",
        lastLogin: [],
        tqsPoints1: "",
        tqsPoints2: "",
        isInternalTrainingAuthorized: ""
      }
    };
  },
  created() {
    this.$watch(
      "columns",
      function(newVal, oldVal) {
        this.$nextTick(() => {
          this.$refs.userDetailTable.doLayout();
          this.tableKey = `${Math.random()}`;
        });
      },
      { deep: true }
    );
  },
  mounted() {
    if (sessionStorage.getItem("detail")) {
      this.getSchoolWebModuleMessageListFunc();
    } else {
      this.getUserDetail(true);
    }
    // this.getUserDetail(true);
    // this.getSchoolWebModuleMessageListFunc()
  },
  methods: {
    // input为数字类型，输入框不允许输入'e,E'和'+,-'
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    reset() {
      this.$refs.queryForm.resetFields();
      this.getUserDetail(false);
    },
    // 个人用户一览检索
    getUserDetail(val) {
      this.pageLoading = true;
      if (val) {
        this.currentPage = 1;
        this.total = 0;
        this.tmpQueryStr = this.queryForm;
      }
      // 换页时，检索条件还原
      this.queryForm = this.tmpQueryStr;
      // tqs积分
      // if (
      //   (this.tmpQueryStr.tqsPoints1 == "" &&
      //     this.tmpQueryStr.tqsPoints2 != "") ||
      //   (this.tmpQueryStr.tqsPoints2 == "" && this.tmpQueryStr.tqsPoints1 != "")
      // ) {
      //   this.$message.error(this.$t("p0213.checkPoints"));
      //   this.pageLoading = false;
      //   return;
      // }
      let url = "/api/individualQuery/selectUserList";
      this.$http
        .post(
          url,
          qs.stringify({
            ...this.tmpQueryStr,
            currentSize: (this.currentPage - 1) * this.pageSize,
            pageSize: this.pageSize,
            total: this.total
          })
        )
        .then(response => {
          this.pageLoading = false;
          this.response = JSON.stringify(response.data);
          if (response.data.code === 200) {
            this.individualUserDetails = response.data.data;
            //判断是否初始化
            if (this.currentPage == 1) {
              this.individualUserDetails = response.data.data;
              this.total = this.individualUserDetails[0].total;
            } else {
              this.individualUserDetails = response.data.data;
            }
          } else {
            this.individualUserDetails = [];
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          this.pageLoading = false;
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 个人用户详细信息取得
    detail(idx, userId) {
      // alert("功能开发中，请耐心等待！");
      let p0212 = JSON.stringify({
        userID: userId,
        locationCode1: idx.documentAppendix01,
        locationCode2: idx.documentAppendix02,
        currentPage: this.currentPage,
        imageBase64: idx.headPortrait
      });
      sessionStorage.p0212 = p0212;
      sessionStorage.setItem("total", this.total);
      sessionStorage.setItem("pageSize", this.pageSize);
      let query = JSON.stringify({
        queryCriteria: this.tmpQueryStr.queryCriteria,
        existingCompany: this.tmpQueryStr.existingCompany,
        salesPerson: this.tmpQueryStr.salesPerson,
        position: this.tmpQueryStr.position,
        tqsOperation: this.tmpQueryStr.tqsOperation,
        lastLogin: this.tmpQueryStr.lastLogin,
        tqsPoints1: this.tmpQueryStr.tqsPoints1,
        tqsPoints2: this.tmpQueryStr.tqsPoints2,
        isInternalTrainingAuthorized: this.tmpQueryStr.isInternalTrainingAuthorized
      });
      sessionStorage.setItem("queryCriteria", query);
      // 显隐列
      let showHide = { columns: this.columns };
      sessionStorage.setItem("showHide", JSON.stringify(showHide));
      // 显隐搜索
      sessionStorage.setItem("showSearch", JSON.stringify(this.showSearch));
      // console.log("total",this.total)
      // console.log("pageSize",this.pageSize)
      // console.log("p0212"+p0212)
      // 跳转指定页面
      this.$router.push({
        path: "/views/CustomerInfoBase/P0213"
      });
    },
    // 头像图片显示
    viewHeadPortrait(imgCodeStr) {
      return imgCodeStr == null
        ? this.defaultImg
        : "data:image/png;base64," + imgCodeStr;
    },
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      //判断更改页码是否需要查询
      if (
        this.individualUserDetails == undefined ||
        this.individualUserDetails.length <= 0
      ) {
        return;
      }
      this.getUserDetail(false);
      console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getUserDetail(false);
      console.log(`当前页: ${val}`);
    },
    //返回跳转前的页面
    getSchoolWebModuleMessageListFunc() {
      //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if (sessionStorage.getItem("detail")) {
        //如果有这个就读取缓存里面的数据
        this.currentPage = Number(sessionStorage.getItem("currentPage"));
        this.total = Number(sessionStorage.getItem("total"));
        this.pageSize = Number(sessionStorage.getItem("pageSize"));
        this.tmpQueryStr = JSON.parse(sessionStorage.getItem("queryCriteria"));
        this.columns = JSON.parse(sessionStorage.getItem("showHide")).columns;
        console.log("🚀 ~ file: P0212.vue:582 ~ getSchoolWebModuleMessageListFunc ~ this.columns:", this.columns)
        this.$refs.rightToolbarRef.refresh(this.columns)
        this.showSearch = JSON.parse(sessionStorage.getItem("showSearch"));
        this.getUserDetail(false);
        sessionStorage.removeItem("detail");
      } else {
        this.currentPage = 1;
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPage");
        sessionStorage.removeItem("total");
      }
    },
    // 导出优惠码
    exportCouponCode() {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      // tqs积分
      if (
        (this.queryForm.tqsPoints1 == "" && this.queryForm.tqsPoints2 != "") ||
        (this.queryForm.tqsPoints2 == "" && this.queryForm.tqsPoints1 != "")
      ) {
        this.$message.error(this.$t("p0213.checkPoints"));
        loading.close();
        return;
      }
      let url = "/api/individualQuery/downloadCouponCode";
      this.$http
        .post(url, { ...this.queryForm }, { responseType: "blob" })
        .then(response => {
          console.log("文件下载成功", response.data);
          const blob = new Blob([response.data]);
          console.log("blob", blob);
          this.formVisible = false;
          if (blob.size == 0) {
            this.$message({
              message: this.$t("p0212.existCoupon"),
              type: "warning"
            });
            loading.close();
          } else {
            const fileName =
              this.$t("p0212.couponFileName") +
              moment(now()).format("YYYY-MM-DD") +
              this.$t("p0212.couponFileFormat");
            //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
            //IE10以上支持blob，但是依然不支持download
            if ("download" in document.createElement("a")) {
              console.log("download1");
              //支持a标签download的浏览器
              const link = document.createElement("a"); //创建a标签
              link.download = fileName; //a标签添加属性
              link.style.display = "none";
              link.href = URL.createObjectURL(blob);
              document.body.appendChild(link);
              link.click(); //执行下载
              URL.revokeObjectURL(link.href); //释放url
              document.body.removeChild(link); //释放标签
            } else {
              // console.log("download2");
              navigator.msSaveBlob(blob, fileName);
            }
            loading.close();
          }
        })
        .catch(err => {
          console.log(err);
          this.$message.error(this.$t("p0212.errorCoupon"));
          loading.close();
        });
    }
  }
};
</script>

<style lang="scss" scoped>
#mainDiv {
  width: 94%;
  padding-left: 3%;
  padding-top: 1%;
  // border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-form-item {
  margin-bottom: 5px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

// >>> .el-form-item__label {
//   font-size: 16px;
//   font-weight: bold;
//   color: #333333;
// }
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
// >>>.el-table .cell{
//   // line-height: 30px;
//   // height: 30px;
// }
>>> .el-table .el-table__cell {
  // padding: 8.5px 0;
  padding-top: 8.5px;
  padding-bottom: 1.5px;
}

// 取消input的上下箭头
>>> input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

>>> input::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
}

>>> input[type="number"] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/views/CustomerInfoBase/P0212.vue